import { animated, easings, useSpring } from '@react-spring/web';

import { CardImg } from '@sorare/core/src/components/card/CardImg';

type Props = {
  cardPictureUrl: string;
  shouldAnimate: boolean;
  onAnimationEnd: () => void;
  isFirstAnimatingSlot: boolean;
};

export const AnimatingSlot = ({
  isFirstAnimatingSlot,
  cardPictureUrl,
  shouldAnimate,
  onAnimationEnd,
}: Props) => {
  const styles = useSpring({
    from: {
      opacity: 0,
      scale: 1.3,
      brightness: 1,
    },
    to: [
      {
        opacity: 1,
        scale: 1,
        brightness: 1.2,
      },
      {
        opacity: 1,
        scale: 1,
        brightness: 1,
      },
    ],
    config: {
      duration: 400,
      easing: easings.easeOutCubic,
    },
    delay: isFirstAnimatingSlot ? 1300 : 500,
    pause: !shouldAnimate,

    onRest: () => {
      onAnimationEnd();
    },
  });

  return (
    <animated.div
      style={{
        opacity: styles.opacity,
        scale: styles.scale,
        filter: styles.brightness.to(brightness => `brightness(${brightness})`),
      }}
    >
      <CardImg src={cardPictureUrl} width={160} />
    </animated.div>
  );
};
